<template>
  <div class="page">
    <!-- 员工排名新 -->
    <div class="screenLine" style="padding: 20px 20px 0 20px">
      <el-select filterable style="width: 150px" v-model="shopId" value-key="shopId" placeholder="门店" size="medium"
        @change="changeshop">
        <el-option v-for="item in shopOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-select filterable style="width: 150px" v-model="department" value-key="department" placeholder="部门" size="medium"
        @change="changeshop">
        <el-option v-for="item in filtersList1" :key="item.text" :label="item.value" :value="item.value">
        </el-option>
      </el-select>
      <el-button type="waring" class="addClick" @click="handleResetClick">重置</el-button>

    </div>
    <div class="tableBox">
      <el-table :data="filtrateList.length ? filtrateList : tableData" style="width: 100%" stripe>
        <el-table-column label="排名">
          <template slot-scope="props">
            {{ parseInt(props.$index + 1) }}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="姓名">

        </el-table-column>
        <el-table-column label="门店" :filters="filtersList" :filter-method="filterTag" filter-placement="top-end"
          align="center" :filter-multiple="false">
          <template slot-scope="props">
            {{ $public.getShopNameById(props.row.shopId) }}
          </template>
        </el-table-column>
        <el-table-column prop="department" label="部门" :filters="filtersList1" :filter-method="filterTag1"
          filter-placement="top-end" align="center" :filter-multiple="false">
        </el-table-column>
        <el-table-column prop="petCount" label="活体" sortable>
        </el-table-column>

        <el-table-column label="活体金额" sortable prop="petMoney.money">
          <!-- <template slot-scope="scope">
            {{ scope.row.petMoney ? scope.row.petMoney.money : '0' }}
          </template> -->
        </el-table-column>
        <el-table-column label="服务数量" sortable prop="serviceCount">
        </el-table-column>
        <el-table-column prop="sumMoney.money" label="总销售金额">

        </el-table-column>


      </el-table>

    </div>


  </div>
</template>
  
<script>
export default {

  data() {
    return {
      visible: true,
      curDate: new Date(),
      tableData: [],
      shopId: null,
      filtrateList: [],
      department: null,
      filtersList: [
        {
          value: "5e9412e0b2bfbc089daerr12",
          text: "北环"
        },
        {
          value: "5e9412e0b2bfbc089daerr15",
          text: "东区"
        },
        {
          value: "5e9412e0b2bfbc089daerr16",
          text: "二七"
        },
        {
          value: "5e9412e0b2bfbc089daerr18",
          text: "云尚"
        }
      ],

      filtersList1: [
        {
          text: "销售",
          value: "销售"
        },
        {
          text: "美容",
          value: "美容"
        },
        {
          text: "医疗",
          value: "医疗"
        }
      ],
      shopOptions: [{
        value: '5e9412e0b2bfbc089daerr12',
        label: '金水区店'
      }, {
        value: '5e9412e0b2bfbc089daerr15',
        label: '东区店'
      },{
        value: '5e9412e0b2bfbc089daerr18',
        label: '郑东新区店'
      }],
    };
  },
  computed: {
    //  filtered(){
    //   return this.tableData.filter(item=>item.includes(this.shopId))
    //  }
  },
  props: {
        refresh: {
            default: 0,
        },
    },
    watch: {
        refresh() {
          this.getTableData();
        },
    },
  created() {
    this.curDate = new Date();
    sessionStorage.setItem("pkMonth", this.$public.FTimeStr10(this.curDate));
    this.getTableData();
  },
  mounted() {
   
  },
  methods: {
    handleResetClick() {
      this.shopId='';
      this.department=''
      this.filtrateList=[]
      this.getTableData();
    },

    filterTag1(value, row) {
      console.log(value, '？？、po');
      return row.department === value;
    },
    filterTag(value, row) {
      return this.$public.getShopNameById(row.shopId) === this.$public.getShopNameById(value);
    },
    changeshop() {
      console.log(this.shopId, this.department, 'val');
      if (this.shopId) {
        let value = this.shopId
        let arr = this.tableData
        let filterArr = (arr, value) => {
          return arr.filter(item => {
            for (let key in item) {
              if (item[key] === value) {
                return true;
              }
            }
            return false;
          });
        }
        let result = filterArr(arr, value);
        this.filtrateList = result

        if (this.department) {
          let value = this.department
          let arr = this.filtrateList
          let filterArr = (arr, value) => {
            return arr.filter(item => {
              for (let key in item) {
                if (item[key] === value) {
                  return true;
                }
              }
              return false;
            });
          }

          let result = filterArr(arr, value);

          this.filtrateList = result
        }
      }else {
        if (!this.shopId&&this.department) {
          let value = this.department
          let arr = this.tableData
          let filterArr = (arr, value) => {
            return arr.filter(item => {
              for (let key in item) {
                if (item[key] === value) {
                  return true;
                }
              }
              return false;
            });
          }

          let result = filterArr(arr, value);

          this.filtrateList = result
        }
      }



    },

    getTableData() {
      let params = {
        month: this.$public.FTime(
          sessionStorage.getItem("pkMonth"),
          "YYYY-MM"
        ), // 月份信息(2021-10)
      };
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_zichan +"/api/Performance/GetStaffPerformanceRanking", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.tableData = res.data;
            console.log(res, '--0000');
          }
        });
    },

  }
}
</script>
  
<style lang="scss" scoped>
.el-table__column-filter-trigger i {
  font-size: 19px !important;

  &:before {
    content: "筛选∨";
    font-size: 16px;
    margin-left: 5px;
  }
}

.el-icon-arrow-down:before {
  content: "\e6df";
  font-size: 19px;
}
</style>